import { Component, OnInit, Inject, HostListener } from '@angular/core';

import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material';
import { MatSnackBar } from '@angular/material';

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss']
})
export class ToastComponent implements OnInit {

    constructor(
        @Inject(MAT_SNACK_BAR_DATA) public data: any,
        private snackBar: MatSnackBar,
        private _snackRef: MatSnackBarRef<ToastComponent>,
    ) { }

    ngOnInit() {
    }

    dismiss() {
        this.snackBar.dismiss()
    }

    @HostListener('mouseenter', ['$event.target']) mouseEnter() {
        // Actions
    }

    @HostListener('mouseleave', ['$event.target']) mouseLeave() {
        // Actions
    }
    

}